import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import DeniedToast from '@/components/toasts/DeniedToast';
import DeletesToast from '@/components/toasts/DeletesToast';
import ArchivedToast from '@/components/toasts/ArchivedToast';
import ApprovedToast from '../components/ApprovedToast';
import TransferToast from '../components/TransferToast';
import actions from '../constants';

export function* approveRequestSuccessToast({ items }) {
  yield call(showToast, <ApprovedToast items={items} />);
}

export function* approveRequestErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.approve" errors={items} />);
}

export function* denyRequestSuccessToast({ items }) {
  yield call(showToast, <DeniedToast items={items} />);
}

export function* denyRequestErrorToast({ items }) {
  yield call(showToast, <ErrorsToast operation="actions.deny" errors={items} />);
}

export function* destroyRequestToast({ isArchival, items, silent }) {
  if (!silent) {
    const Component = isArchival ? ArchivedToast : DeletesToast;
    yield call(showToast, <Component items={items} isArchival={isArchival} />);
  }
}

export function* destroyRequestErrorToast({ isArchival, items }) {
  const operation = isArchival ? 'actions.archival' : 'actions.delete';
  yield call(showToast, <ErrorsToast operation={operation} errors={items} />);
}

export function* transferRequestSuccessToast({ items, automatic }) {
  yield call(showToast, <TransferToast items={items} automatic={automatic} />);
}

export function* transferRequestErrorToast({ items, automatic }) {
  yield call(
    showToast,
    <ErrorsToast
      operation={automatic ? 'actions.transfer' : 'actions.mark.transfer'}
      errors={items}
    />,
  );
}

export default function* requestsToasts() {
  yield takeEvery(actions.APPROVE_REQUEST_SUCCESS, approveRequestSuccessToast);
  yield takeEvery(actions.APPROVE_REQUEST_ERROR, approveRequestErrorToast);
  yield takeEvery(actions.DENY_REQUEST_SUCCESS, denyRequestSuccessToast);
  yield takeEvery(actions.DENY_REQUEST_ERROR, denyRequestErrorToast);
  yield takeEvery(actions.DESTROY_REQUESTS, destroyRequestToast);
  yield takeEvery(actions.DESTROY_REQUESTS_ERROR, destroyRequestErrorToast);
  yield takeEvery(actions.TRANSFER_REQUEST_SUCCESS, transferRequestSuccessToast);
  yield takeEvery(actions.TRANSFER_REQUEST_ERROR, transferRequestErrorToast);
}
